import Seo from "@/components/Seo";
import { metaDescription } from "@/lib/seo";
import SiteNav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import EventsSection from "@/components/landing/EventsSection";
import ShopSection from "@/components/landing/ShopSection";
import Testimonials from "@/components/landing/Testimonials";
import DonateSection from "@/components/landing/DonateSection";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-ink text-foreground">
      <Seo
        title="AB Hunter Consulting USA — Building Bridges, Elevating Communities, Transforming Leaders"
        siteName="AB Hunter Consulting USA"
        description={metaDescription("Strategic education consulting, mentorship, workshops and public speaking. Register for upcoming events and shop Thrills & Chills of Leadership books and merch.")}
        image="/assets/hero-portrait.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "AB Hunter Consulting USA",
          description: "Full-service strategic consulting practice for education, leadership and community transformation.",
          telephone: "+1-225-603-4116",
          email: "engage@abhunter.us",
        }}
      />
      <SiteNav />
      <div className="lg:pl-64">
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Services />
          <EventsSection />
          <ShopSection />
          <Testimonials />
          <DonateSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </div>
  );
}
